module.exports = __webpack_public_path__ + "static/media/armband.80da8eb4.jpg";